import useMediaQuery from '@mui/material/useMediaQuery';

export default function useIsLargeScreen() {
  return useMediaQuery('(min-width:1000px)');
}
